import Vue from "vue";


Vue.component(
    "invoice-mainstep",
    require("./Components/Views/SuperAdmin/Invoice/MainStep").default
);
Vue.component(
    "invoice-index",
    require("./Components/Views/SuperAdmin/Invoice/Index").default
);
Vue.component(
    "invoice-datatable",
    require("./Components/Views/SuperAdmin/Invoice/Datatable").default
);
Vue.component(
    "invoice-view",
    require("./Components/Views/SuperAdmin/Invoice/View").default
);
Vue.component(
    "invoice-addmodal",
    require("./Components/Views/SuperAdmin/Invoice/AddModal").default
);
Vue.component(
    "invoice-editmodal",
    require("./Components/Views/SuperAdmin/Invoice/EditModal").default
);

Vue.component(
    "invoice-list",
    require("./Components/Views/SuperAdmin/Invoice/List").default
);

//Task
Vue.component(
    "task-mainstep",
    require("./Components/Views/SuperAdmin/Task/MainStep").default
);
Vue.component(
    "task-index",
    require("./Components/Views/SuperAdmin/Task/Index").default
);
Vue.component(
    "task-create",
    require("./Components/Views/SuperAdmin/Task/Create").default
);
Vue.component(
    "task-edit",
    require("./Components/Views/SuperAdmin/Task/Edit").default
);

Vue.component(
    "task-mainstep-mytask",
    require("./Components/Views/SuperAdmin/Task/MainStepMyTask").default
);
Vue.component(
    "task-mytask",
    require("./Components/Views/SuperAdmin/Task/MyTasks").default
);
Vue.component(
    "task-mytask-view",
    require("./Components/Views/SuperAdmin/Task/MytaskView").default
);
Vue.component(
    "task-mytaskmodal",
    require("./Components/Views/SuperAdmin/Task/MyTaskModal").default
);

Vue.component(
    "task-taskedit",
    require("./Components/Views/SuperAdmin/Task/TaskEdit").default
);
Vue.component(
    "task-detail",
    require("./Components/Views/SuperAdmin/Task/Detail").default
);
Vue.component(
    "task-attach-document",
    require("./Components/Views/SuperAdmin/Task/AttachDocument").default
);

Vue.component(
    "task-attach-questionnaire",
    require("./Components/Views/SuperAdmin/Task/AttachQuestionnaire").default
);

Vue.component(
    "task-form-mainstep",
    require("./Components/Views/SuperAdmin/Task/Form/MainStep").default
);
Vue.component(
    "task-form-index",
    require("./Components/Views/SuperAdmin/Task/Form/Index").default
);
Vue.component(
    "TaskFormDetail",
    require("./Components/Views/SuperAdmin/Task/Form/FormDetail").default
);

Vue.component(
    "FormResponse",
    require("./Components/Views/SuperAdmin/Task/Form/FormResponse").default
);
Vue.component(
    "FormEndorseModal",
    require("./Components/Views/SuperAdmin/Task/Form/FormEndorseModal").default
);
Vue.component(
    "AssignTaskForm",
    require("./Components/Views/SuperAdmin/Task/Form/AssignTaskForm").default
);
Vue.component(
    "guest-forms",
    require("./Components/Views/SuperAdmin/Task/Form/GuestFormsListing").default
);
Vue.component(
    "task-forms-view-modal",
    require("./Components/Views/SuperAdmin/Task/Form/FormViewModal").default
);
Vue.component(
    "task-form-progress",
    require("./Components/Views/SuperAdmin/Task/Form/FormProgress").default
);

Vue.component(
    "task-endorsement-message",
    require("./Components/Views/SuperAdmin/Task/EndorsementMessage").default
);


//Task Category
Vue.component(
    "taskcategory-index",
    require("./Components/Views/SuperAdmin/TaskCategory/Index").default
);
Vue.component(
    "taskcategory-addmodal",
    require("./Components/Views/SuperAdmin/TaskCategory/AddModal").default
);

//Tickets
Vue.component(
    "tickets-index",
    require("./Components/Views/SuperAdmin/Tickets/Index").default
);
Vue.component(
    "tickets-addmodal",
    require("./Components/Views/SuperAdmin/Tickets/AddModal").default
);
Vue.component(
    "tickets-view",
    require("./Components/Views/SuperAdmin/Tickets/View").default
);

//Ticket Setting
Vue.component(
    "tickets-settings-index",
    require("./Components/Views/SuperAdmin/Tickets/Settings/Index").default
);

Vue.component(
    "tickets-settings-agent",
    require("./Components/Views/SuperAdmin/Tickets/Settings/Agent").default
);
Vue.component(
    "tickets-settings-agentmodal",
    require("./Components/Views/SuperAdmin/Tickets/Settings/Modal/AgentModal")
        .default
);

Vue.component(
    "tickets-settings-type",
    require("./Components/Views/SuperAdmin/Tickets/Settings/Type").default
);
Vue.component(
    "tickets-settings-typemodal",
    require("./Components/Views/SuperAdmin/Tickets/Settings/Modal/TypeModal")
        .default
);

Vue.component(
    "tickets-settings-channel",
    require("./Components/Views/SuperAdmin/Tickets/Settings/Channel").default
);
Vue.component(
    "tickets-settings-channelname",
    require("./Components/Views/SuperAdmin/Tickets/Settings/Modal/ChannelModal")
        .default
);

Vue.component(
    "tickets-settings-reply",
    require("./Components/Views/SuperAdmin/Tickets/Settings/Reply").default
);
Vue.component(
    "tickets-settings-replymodal",
    require("./Components/Views/SuperAdmin/Tickets/Settings/Modal/ReplyModal")
        .default
);

//User Management
Vue.component(
    "user-addmodal",
    require("./Components/Views/UserRoles/Users/UserAddModal").default
);

//Admin Ticket
Vue.component(
    "adminticket-index",
    require("./Components/Views/SuperAdmin/AdminTickets/Index").default
);
Vue.component(
    "adminticket-edit",
    require("./Components/Views/SuperAdmin/AdminTickets/Edit").default
);
Vue.component(
    "adminticket-editmodal",
    require("./Components/Views/SuperAdmin/AdminTickets/EditModal").default
);

Vue.component(
    "task-update",
    require("./Components/Views/SuperAdmin/Task/Update").default
);

//Form Builder
Vue.component(
    "formbuilder-index",
    require("./Components/Views/SuperAdmin/FormBuilder/Index").default
);

//Packages
Vue.component(
    "packages-index",
    require("./Components/Views/SuperAdmin/Packages/Index").default
);
Vue.component(
    "packages-addmodal",
    require("@Views/SuperAdmin/Packages/PackageAddModal").default
);
Vue.component(
    "packages-view",
    require("./Components/Views/SuperAdmin/Packages/Packages").default
);
Vue.component(
    "package-formassignmodal",
    require("./Components/Views/SuperAdmin/Packages/PackageTemplateAssignModal").default
);
Vue.component(
    "packages-detail",
    require("./Components/Views/SuperAdmin/Packages/Detail").default
);
Vue.component(
    "packages-paymentmodal",
    require("./Components/Views/SuperAdmin/Packages/PaymentModal").default
);

Vue.component(
    "package-forms-modal",
    require("./Components/Views/SuperAdmin/Packages/PackageTemplateViewModal").default
);
Vue.component(
    "package-companies-modal",
    require("./Components/Views/SuperAdmin/Packages/PackageCompaniesModal").default
);
Vue.component(
    "check-password-form-link",
    require("./Components/Views/SuperAdmin/Packages/CheckPasswordFormLink").default
);
Vue.component(
    "form-preview",
    require("./Components/Views/SuperAdmin/Packages/FormPreview").default
);
Vue.component(
    "guest-form-preview",
    require("./Components/Views/SuperAdmin/Packages/GuestFormPreview").default
);

//Package Includes
Vue.component(
    "packages-include-index",
    require("./Components/Views/SuperAdmin/Packages/Include/Index").default
);
Vue.component(
    "packages-include-addmodal",
    require("./Components/Views/SuperAdmin/Packages/Include/AddModal").default
);

//embership
Vue.component(
    "membership-index",
    require("./Components/Views/SuperAdmin/Membership/Index").default
);
Vue.component(
    "membership-historyreport",
    require("./Components/Views/SuperAdmin/Membership/historyreport").default
);
Vue.component(
    "all-member",
    require("./Components/Views/SuperAdmin/Membership/all").default
);
Vue.component(
    "add-members",
    require("./Components/Views/SuperAdmin/Membership/addmember").default
);
Vue.component(
    "membership-members",
    require("./Components/Views/SuperAdmin/Membership/Members").default
);

Vue.component(
    "membership-member",
    require("./Components/Views/SuperAdmin/Membership/Member").default
);

//Suppliermembership
Vue.component(
    "suppliermembership-index",
    require("./Components/Views/SuperAdmin/SupplierMembership/Index").default
);

//Audit Request
Vue.component(
    "auditrequest-index",
    require("./Components/Views/SuperAdmin/AuditRequest/Index").default
);
Vue.component(
    "auditrequest-datatable",
    require("./Components/Views/SuperAdmin/AuditRequest/Datatable").default
);
Vue.component(
    "auditrequest-view",
    require("./Components/Views/SuperAdmin/AuditRequest/View").default
);

//Buyer
Vue.component(
    "allbuyers-index",
    require("./Components/Views/SuperAdmin/Client/Buyer/Index").default
);
Vue.component(
    "buyer-request-index",
    require("./Components/Views/SuperAdmin/Client/Buyer/Request/Index").default
);
Vue.component(
    "buyer-request-status",
    require("./Components/Views/SuperAdmin/Client/Buyer/Request/RequestStatus")
        .default
);
Vue.component(
    "buyer-request-card",
    require("./Components/Views/SuperAdmin/Client/Buyer/Request/RequeststatusCard")
        .default
);
Vue.component(
    "buyer-request-detail",
    require("./Components/Views/SuperAdmin/Client/Buyer/Request/StatusDetail")
        .default
);
Vue.component(
    "buyer-request-detail-products",
    require("./Components/Views/SuperAdmin/Client/Buyer/Request/Products").default
);
Vue.component(
    "buyer-request-detail-review",
    require("./Components/Views/SuperAdmin/Client/Buyer/Request/Review").default
);
Vue.component(
    "buyer-profile-view",
    require("./Components/Views/SuperAdmin/Client/Buyer/Request/ProfileView.vue")
        .default
);

// Vue.component('allbuyers-profile', require('./Components/Views/Client/Buyer/BuyerCard').default);

//Supplier
Vue.component(
    "allsupplier-index",
    require("./Components/Views/SuperAdmin/Client/Supplier/Index").default
);
Vue.component(
    "allsupplier-index-grid",
    require("./Components/Views/SuperAdmin/Client/Supplier/IndexCardView/GridView").default
);
Vue.component(
    "allsupplier-index-card",
    require("./Components/Views/SuperAdmin/Client/Supplier/IndexCardView/ProfileCard").default
);

Vue.component(
    "allsupplier-chat",
    require("./Components/Views/SuperAdmin/Client/Supplier/Chat").default
);

//Category
Vue.component(
    "categories-index",
    require("./Components/Views/SuperAdmin/Categories/Index").default
);
Vue.component(
    "category-addmodal",
    require("./Components/Views/SuperAdmin/Categories/AddModal").default
);
Vue.component(
    "category-card",
    require("./Components/Views/SuperAdmin/Categories/grid-view/CategoryCard")
        .default
);
Vue.component(
    "category-pro-addmodal",
    require("./Components/Views/SuperAdmin/Categories/grid-view/AddModal").default
);

//support request
Vue.component(
    "supportrequest-index",
    require("./Components/Views/SuperAdmin/SupportRequest/Index").default
);
Vue.component(
    "supportrequest-datatable",
    require("./Components/Views/SuperAdmin/SupportRequest/Datatable").default
);
Vue.component(
    "supportrequest-view",
    require("./Components/Views/SuperAdmin/SupportRequest/View").default
);

//document library
Vue.component(
    "documentlibrary-index",
    require("./Components/Views/SuperAdmin/DocumentLibrary/Index").default
);
Vue.component(
    "documentlibrary-addmodal",
    require("./Components/Views/SuperAdmin/DocumentLibrary/AddModal").default
);
Vue.component(
    "documentlibrary-AddUpdateFolderModal",
    require("./Components/Views/SuperAdmin/DocumentLibrary/AddUpdateFolderModal").default
);
Vue.component(
    "import-folder-forms-styling-modal",
    require("./Components/Views/SuperAdmin/DocumentLibrary/ImportFormsStyleModal").default
);
Vue.component(
    "documentlibrary-formassignmodal",
    require("./Components/Views/SuperAdmin/DocumentLibrary/SelectFormModal").default
);
Vue.component(
    "app-formBuilder-modal",
    require("./Components/Views/SuperAdmin/DocumentLibrary/FormBuilderModal").default
);
Vue.component(
    "app-document-child-list-modal",
    require("./Components/Views/SuperAdmin/DocumentLibrary/DocumentChildListModal").default
);
Vue.component(
    "documentlibrary-report",
    require("./Components/Views/SuperAdmin/DocumentLibrary/Report").default
);

Vue.component(
    "documentlibrary-mydocument",
    require("./Components/Views/SuperAdmin/DocumentLibrary/MyDocument").default
);

Vue.component(
    "documentlibrary-mydocument-grid",
    require("./Components/Views/SuperAdmin/DocumentLibrary/DocumentCardGrid/GridView").default
);

Vue.component(
    "documentlibrary-mydocument-card",
    require("./Components/Views/SuperAdmin/DocumentLibrary/DocumentCardGrid/CardView").default
);

Vue.component(
    "documentlibrary-save-response-form",
    require("./Components/Views/SuperAdmin/DocumentLibrary/SaveResponseForms").default
);

Vue.component(
    "save-response-form-modal",
    require("./Components/Views/SuperAdmin/DocumentLibrary/SaveResponseModal").default
);

Vue.component(
    "save-response-category-addmodal",
    require("./Components/Views/SuperAdmin/DocumentLibrary/SaveResponseCategoryAddModal").default
);

Vue.component(
    "save-response-category-importmodal",
    require("./Components/Views/SuperAdmin/DocumentLibrary/SaveResponseCategoryImportModal").default
);


Vue.component(
    "documentlibrary-add-category",
    require("./Components/Views/SuperAdmin/DocumentLibrary/AddCategory").default
);

Vue.component(
    "documentlibrary-add-forminformation",
    require("./Components/Views/SuperAdmin/DocumentLibrary/AddFormInformation").default
);

Vue.component(
    "form-log-modal",
    require("./Components/Views/SuperAdmin/DocumentLibrary/FormLogModal").default
);

Vue.component(
    "documentlibrary-form-theme-modal",
    require("./Components/Views/SuperAdmin/DocumentLibrary/FormThemeModal").default
);

//Customers
Vue.component(
    "customer-index",
    require("./Components/Views/CustomerManagement/Index.vue").default
);
Vue.component
('customer-management-navigator', require('@Views/CustomerManagement/CustomerManagementNavigator')
    .default);

Vue.component(
    "customer-addmodal",
    require("./Components/Views/CustomerManagement/AddModal.vue").default
);

Vue.component(
    "comments-view",
    require("./Components/Views/SuperAdmin/Task/ViewComment").default
);
//Customer Invoice
Vue.component(
    "customerinvoice-mainstep",
    require("./Components/Views/Client/Buyer/CustomerInvoice/MainStep").default
);
Vue.component(
    "customerinvoice-index",
    require("./Components/Views/Client/Buyer/CustomerInvoice/Index").default
);
Vue.component(
    "customerinvoice-list",
    require("./Components/Views/Client/Buyer/CustomerInvoice/List").default
);
Vue.component(
    "customerinvoice-view",
    require("./Components/Views/Client/Buyer/CustomerInvoice/View").default
);
Vue.component(
    "customerinvoice-addmodal",
    require("./Components/Views/Client/Buyer/CustomerInvoice/AddModal").default
);

Vue.component(
    "customerinvoice-editmodal",
    require("./Components/Views/Client/Buyer/CustomerInvoice/EditModal").default
);

//personal invoice
Vue.component(
    "personalinvoice-mainstep",
    require("./Components/Views/Client/Buyer/PersonalInvoice/MainStep").default
);
Vue.component(
    "personalinvoice-index",
    require("./Components/Views/Client/Buyer/PersonalInvoice/Index").default
);
Vue.component(
    "personalinvoice-view",
    require("./Components/Views/Client/Buyer/PersonalInvoice/View").default
);

Vue.component(
    "request-company-detail",
    require("./Components/Views/SuperAdmin/Client/Buyer/Request/CompanyDetails")
        .default
);

Vue.component(
    "request-company-forms",
    require("./Components/Views/SuperAdmin/Client/Buyer/Request/Forms").default
);

Vue.component(
    "request-company-form-responses",
    require("./Components/Views/SuperAdmin/Client/Buyer/Request/Responses")
        .default
);

Vue.component(
    "certificate-audit-request-modal",
    require("./Components/Views/SuperAdmin/Client/Buyer/Request/AuditRequestModal")
        .default
);

//task view 
Vue.component(
    "task-viewmodal",
    require("./Components/Views/SuperAdmin/Task/Document/ViewTaskModal").default
);
Vue.component(
    "task-detail-view",
    require("./Components/Views/SuperAdmin/Task/Document/Detail").default
);
Vue.component(
    "task-view-attach-document",
    require("./Components/Views/SuperAdmin/Task/Document/ViewAttachDocument").default
);

//task report
Vue.component(
    "task-report-index",
    require("./Components/Views/SuperAdmin/Task/Report/Index").default
);
Vue.component(
    "task-report-add-modal",
    require("./Components/Views/SuperAdmin/Task/Report/AddModal").default
);
Vue.component(
    "task-report-detail",
    require("./Components/Views/SuperAdmin/Task/Report/Detail").default
);

//stages
Vue.component(
    "stage-index",
    require("./Components/Views/SuperAdmin/Stages/Index")
        .default
);

Vue.component(
    "stage-addmodal",
    require("./Components/Views/SuperAdmin/Stages/AddModal").default);

Vue.component(
    "document-watch-index",
    require("./Components/Views/SuperAdmin/DocumentsWatch/Index").default);

// Form Builder File Upload

Vue.component(
    "file-upload-modal",
    require("./Components/Views/CustomFormBuilder/File/FileUploadModal").default);

Vue.component(
    "preview-image-modal",
     require("./Components/Views/CustomFormBuilder/File/PreviewImage").default);

Vue.component(
    "file-gallery",
    require("./Components/Views/CustomFormBuilder/File/Gallery").default);

Vue.component(
    "file-upload",
    require("./Components/Views/CustomFormBuilder/File/Upload").default);

//Document Fields
Vue.component(
    "document-fields-index",
    require("./Components/Views/SuperAdmin/DocumentFields/Index")
        .default
);
Vue.component(
    "document-fields-addmodal",
    require("./Components/Views/SuperAdmin/DocumentFields/AddModal")
        .default
);
Vue.component(
    "document-category-addmodal",
    require("./Components/Views/SuperAdmin/DocumentFields/AddCategoryModal")
        .default
);
Vue.component(
    "document-fields-viewmodal",
    require("./Components/Views/SuperAdmin/DocumentFields/ViewFieldsModal")
        .default
);

//Workspace
Vue.component(
    "workspace-index",
    require("./Components/Views/SuperAdmin/Workspace/Index")
        .default
);
Vue.component(
    "workspace-main-content",
    require("./Components/Views/SuperAdmin/Workspace/MainContent")
        .default
);
Vue.component(
    "workspace-jobs-tasks",
    require("./Components/Views/SuperAdmin/Workspace/JobsTasks")
        .default
);
Vue.component(
    "workspace-board",
    require("./Components/Views/SuperAdmin/Workspace/Board")
        .default
);
Vue.component(
    "workspace-calendar",
    require("./Components/Views/SuperAdmin/Workspace/Calendar")
        .default
);
Vue.component(
    "workspace-list",
    require("./Components/Views/SuperAdmin/Workspace/List")
        .default
);
Vue.component(
    "workspace-view",
    require("./Components/Views/SuperAdmin/Workspace/View")
        .default
);
Vue.component(
    "workspace-management",
    require("./Components/Views/SuperAdmin/Workspace/Management")
        .default
);
Vue.component(
    "workspace-add-edit-modal",
    require("./Components/Views/SuperAdmin/Workspace/AddEditModal")
        .default
);

Vue.component(
    "site-task-add-modal",
    require("./Components/Views/SuperAdmin/Workspace/SiteTaskAddModal")
        .default
);

Vue.component('profile-certificates-list', require('./Components/Views/Auth/CertificatesList').default);
Vue.component('job-create-modal', require('./Components/Views/Auth/JobCreateModal').default);
Vue.component('job-template-list', require('./Components/Views/Auth/JobTemplateList').default);
Vue.component('training-list', require('./Components/Views/Auth/TrainingList').default);


// Profile Business Detail
Vue.component('company-business-detail', require('./Components/Views/Auth/BusinessDetail/Index').default);
Vue.component('company-other-business-detail', require('./Components/Views/Auth/BusinessDetail/OtherDetail').default);

    //Contacts
    Vue.component('company-contacts', require('./Components/Views/Auth/BusinessDetail/Contact/Index').default);
    Vue.component('company-contact-modal', require('./Components/Views/Auth/BusinessDetail/Contact/AddEditModal').default);

    //Office
    Vue.component('company-offices', require('./Components/Views/Auth/BusinessDetail/Office/Index').default);
    Vue.component('company-office-modal', require('./Components/Views/Auth/BusinessDetail/Office/AddEditModal').default);
    
    //Headcount
    Vue.component('company-headcounts', require('./Components/Views/Auth/BusinessDetail/Headcount/Index').default);
    Vue.component('company-headcount-modal', require('./Components/Views/Auth/BusinessDetail/Headcount/AddEditModal').default);
    
    //Insursnce
    Vue.component('company-insurance', require('./Components/Views/Auth/BusinessDetail/Insurance/Index').default);
    Vue.component('company-insurance-modal', require('./Components/Views/Auth/BusinessDetail/Insurance/AddEditModal').default);
    
    //Turnover
    Vue.component('company-turnovers', require('./Components/Views/Auth/BusinessDetail/Turnover/Index').default);
    Vue.component('company-turnover-modal', require('./Components/Views/Auth/BusinessDetail/Turnover/AddEditModal').default);
    
    // Accreditations
    Vue.component('company-accreditations', require('./Components/Views/Auth/BusinessDetail/Accreditation/Index').default);
    Vue.component('company-accreditations-modal', require('./Components/Views/Auth/BusinessDetail/Accreditation/AddEditModal').default);

    //Trade Association Details
    Vue.component('company-associations', require('./Components/Views/Auth/BusinessDetail/TradeAssociationDetails/Index').default);
    Vue.component('company-association-modal', require('./Components/Views/Auth/BusinessDetail/TradeAssociationDetails/AddEditModal').default);

    //Trade Refrence Details
    Vue.component('company-refrences', require('./Components/Views/Auth/BusinessDetail/TradeRefrenceDetails/Index').default);
    Vue.component('company-refrence-modal', require('./Components/Views/Auth/BusinessDetail/TradeRefrenceDetails/AddEditModal').default);

    //Safety Incidents
    Vue.component('company-safety-incidents', require('./Components/Views/Auth/BusinessDetail/SafetyIncidents/Index').default);
    Vue.component('company-safety-incident-modal', require('./Components/Views/Auth/BusinessDetail/SafetyIncidents/AddEditModal').default);

    //Staff Training Details
    Vue.component('company-staff-trainings', require('./Components/Views/Auth/BusinessDetail/StaffTrainingDetail/Index').default);
    Vue.component('company-staff-training-modal', require('./Components/Views/Auth/BusinessDetail/StaffTrainingDetail/AddEditModal').default);
